import { z, toJSONSchema } from 'zod';
import Cookies from 'js-cookie';
import { TENANT_STORAGE_KEY } from '@constants/tenant';
import { CartService } from '@services/cart';
import { useServiceRef } from 'hooks/useServiceRef';
import { McpService } from '../mcp';
import { InputSchema, ToolDescriptor, ToolResponse } from '@mcp-b/webmcp-types';

const schema = z.object({
  lineItemId: z
    .union([ z.string(), z.array(z.string()) ])
    .describe('The ID or IDs of the line item to remove from the cart.')
});

export const removeFromCartTool: ToolDescriptor<z.infer<typeof schema>, ToolResponse> = {
  name: 'remove_from_cart',
  description: `Remove a line item from the current user's cart. Schema: ${JSON.stringify(schema.shape)}`,
  inputSchema: toJSONSchema(schema) as InputSchema,
  execute: async ({ lineItemId }: z.infer<typeof schema>): Promise<ToolResponse> => {
    const cartServiceRef = useServiceRef(CartService);
    const mcpServiceRef = useServiceRef(McpService);

    const tenantKey = JSON.parse(Cookies.get(TENANT_STORAGE_KEY) || null)?.key;
    let cart = await cartServiceRef.current.getMyActiveCart(tenantKey);

    cart = await cartServiceRef.current.removeLineItem(
      cart.id,
      cart.version,
      lineItemId
    );

    if (cart) {
      mcpServiceRef.current.triggerCartUpdate(cart);
    }

    return {
      content: [ {
        type: 'text',
        text: `Updated cart with ${
          cart?.lineItems?.length || 0
        } items and total price of ${cart?.totalPrice?.value || 0}. Cart: ${JSON.stringify(cart)}`,
      } ]
    };
  }
};
